import {FacilityCategory, OwnershipType, ProductType, SpecificProduct, SpecificProductItem, Warehouse, ApplicantType, FacilityType} from './CommonModels';
import * as Constants from './Constants';
import { ChecklistModel } from './ChecklistModel';
import {ChangeType, DocumentDetail} from './ApplicationDetail';
import {DocumentRef} from './DocumentRef';
import { UserDto } from './User';

export class Application {
    id: number;
    recieptNumber: string;
    applicationNumber: string;
    name: string;
    applicationTypeID: number;
    regionID: number;
    zoneID: number;
    woredaID: number;
    cityID: number;
    kebele: string;
    houseNo: string;
    phoneNo: string;
    facility: Facility;
    documents: Document[];
    applicationStatusID: number;
    position: string;
    createdBy: number;
    applicationUserAssignments: any[];
    checkListInstances: ChecklistInstance[];
    paymentInfos: PaymentInfo[];
    isLegacyData: boolean;
    applicationCategoryID: number;
    flowTypeID: number;
    checklistComplete: boolean;
    previousApplicationID: number;
    facilityID: number;
    branchOfficeID: number;
    editedFields : string;
    ldeType: string;
    ticketNumber: string;
    applicationInfo: ApplicationInfo;
    productTypeID: number;
    manuLevelID: number;
    manuRiskLevelID: number;
    locationID: number;
    location: Location;
    facilitySpecificProducts: FacilitySpecificProduct[] = [];
    facilitySpecificProductItems: FacilitySpecificProductItem[] = [];
    professionals: Professionals[] = [];
    activeTab: string;

    constructor(incomingObject: any, userID: number, configuredProfessions: string[], checkListItems, appDetail, editedFields?) {
        this.facility = new Facility(incomingObject['facility']);
        this.applicationStatusID = 1;
        this.applicationTypeID = this.facility.applicationTypeID;
        this.position = this.facility.position;
        this.createdBy = userID;
        this.checkListInstances = checkListItems;
        this.productTypeID = incomingObject['facility']['productTypeID'];
        this.manuLevelID = incomingObject['facility']['mLevelID'];
        this.manuRiskLevelID = incomingObject['facility']['mrLevelID'];
        this.phoneNo = incomingObject?.location?.phoneNo || incomingObject?.location?.phoneNumber || incomingObject?.facility?.ownerPhoneNumber || incomingObject?.facility?.ownerPhone || incomingObject?.phoneNo || null;

        const branchOfficeId = incomingObject?.location?.branchOfficeID;
        if (branchOfficeId != null && branchOfficeId !== '') {
          this.branchOfficeID = Number(branchOfficeId);
        }

        this.location = new Location(incomingObject['location']);
        for (let prof of configuredProfessions) {
          let pl = new Professionals( incomingObject['professionals'], prof);
          if(pl.name){
            this.professionals.push(pl);
          }
        }

        if (incomingObject['facility']['specificProductIDs']) {
          for (let fsp of incomingObject['facility']['specificProductIDs']) {
            let fspObj = new FacilitySpecificProduct(fsp);
            this.facilitySpecificProducts.push(fspObj);
          }
        }

        if (incomingObject['facility']['specificProductItemIDs']) {
          for (let fspi of incomingObject['facility']['specificProductItemIDs']) {
            let fspObj = new FacilitySpecificProductItem(fspi);
            this.facilitySpecificProductItems.push(fspObj);
          }
        }

        if (appDetail) {
          this.applicationNumber = appDetail.applicationNumber;
          this.facility.facilityCategoryID = appDetail.facility.facilityCategoryID;
          this.isLegacyData = appDetail.isLegacyData;
          this.applicationCategoryID = appDetail.applicationCategoryID;
          this.flowTypeID = appDetail.flowTypeID;
          this.checklistComplete = appDetail.checklistComplete;
          this.previousApplicationID = appDetail.previousApplicationID;
          this.facilityID = appDetail.facilityID;
          this.facility.id = appDetail.facilityID;
          this.locationID = appDetail.locationID;
          this.location.id = appDetail.locationID;
          this.editedFields = editedFields ? editedFields : null;
          this.createdBy = appDetail.createdBy;
          this.ticketNumber = appDetail.ticketNumber;
        }
    }
}

export class RenewalApplication {
     applicationID: number;
     id: number;
     facilityID: number;
     facility: Facility;
     documents: DocumentDetail[];
     checkListInstances: ChecklistInstance[];
     paymentInfo: PaymentInfo;
     agreedWithDeclaration: boolean;
     applicationCatagoryID: number;
     latestApplicationID: number;
     productTypeID: number;

    constructor(facility, documents, checklistInstances, paymentInfo, applicationID, agreedWithDeclaration) {
        this.facility = facility;
        this.facilityID = facility.id;
        if (applicationID) {
          this.applicationID = applicationID;
        } else {
          this.latestApplicationID = this.facility.applicationID;
        }
        this.documents = documents;
        this.checkListInstances = checklistInstances;
        this.paymentInfo = paymentInfo;
        this.agreedWithDeclaration = agreedWithDeclaration;

    }
}

export class ChangeApplication {
    applicationID: number;
    id: number;
    facilityID: number;
    facility: Facility;
    documents: DocumentDetail[];
    checkListInstances: ChecklistInstance[];
    paymentInfos: PaymentInfo[];
    newApplicationChangeTypes: ApplicationChangeType[];
    changeSummary: string;
    productTypeID: number;
    location: Location;
    specificProductIDs: number[];
    specificProductItemIDs: number[];
    mrLevelID: number;
    mLevelID: number;
    professionals: Professionals[];
    facilitySpecificProductItems: FacilitySpecificProductItem[];

    constructor(appDetail,applicationID,documents, checklistInstances, paymentInfo, newApplicationChangeTypes, changeSummary) {
        this.facility = appDetail.facility;
        if(applicationID){
          this.applicationID = applicationID;
        }
        this.documents = documents;
        this.checkListInstances = checklistInstances;
        this.paymentInfos = [paymentInfo];
        this.newApplicationChangeTypes = newApplicationChangeTypes;
        this.changeSummary = changeSummary;
        this.location = appDetail.location;
        this.specificProductIDs = appDetail.specificProductIDs;
        this.specificProductItemIDs = appDetail.specificProductItemIDs;
        this.productTypeID = appDetail.productTypeID;
        this.mrLevelID = appDetail.mrLevelID;
        this.mLevelID = appDetail.mLevelID;
        this.professionals = appDetail.professionals;
    }
}

export class WarehouseAdditionApplication {
  applicationID: number;
  facilityID: number;
  documents: DocumentDetail[];
  checkListInstances: ChecklistInstance[];
  paymentInfos: PaymentInfo[];
  warehouses: Warehouse[];
  facility: Facility;
  productTypeID: number;
  professionals: Professionals[] = [];

 constructor(facilityID,applicationID,documents, checklistInstances, paymentInfo, warehouses, facility, profForm, profConfig) {
     this.facilityID = facilityID;
     if(applicationID){
       this.applicationID = applicationID;
     }
     this.documents = documents;
     this.checkListInstances = checklistInstances;
     this.paymentInfos = [paymentInfo];
     this.warehouses = warehouses
     this.facility = facility

     for (let prof of profConfig) {
      let pl = new Professionals( profForm, prof);
      this.professionals.push(pl);
    }
 }
}

export class ReplacementApplication{
  applicationID: number;
  id: number;
  facilityID: number;
  facility: Facility;
  documents: DocumentDetail[];
  paymentInfo: PaymentInfo;
  summary: string;
  replacementReasonID: number;
  productTypeID: number;

 constructor(facility,documents,paymentInfo,replacementSummary,replacementReasonID) {
     this.facility = facility;
     this.facilityID = facility.id;
     this.documents = documents;
     this.paymentInfo = paymentInfo;
     this.summary = replacementSummary;
     this.replacementReasonID = replacementReasonID;
 }
}

export class ReturnApplication{
  applicationID: number;
  id: number;
  facilityID: number;
  facility: Facility;
  documents: DocumentDetail[];
  summary: string;
  productTypeID: number;

 constructor(facility,documents,replacementSummary) {
     this.facility = facility;
     this.facilityID = facility.id;
     this.documents = documents;
     this.summary = replacementSummary;
 }
}


export class ApplicationChangeType {
  newApplicationID: number;
  oldApplicationID: number;
  changeTypeID:     number;
  oldValue:         string;
  newValue:         string;
  dataType:         string;
  changeType:       ChangeType;
}

export class ChangeFeeConfig {
  changeTypeRefId: number;
  fee: number;
  changeTypeName: string;
}

export class PaymentInfo {
  id: number;
  recieptNumber: string;
  document: Document;
  documentID: number;
  applicationID: number;
  inspectionID: number; // for inspection module
  payment: any;
  createdDate: string;
  modifiedDate: string;

  constructor(incomingPaymentInfo) {
    this.payment = {};
    if (incomingPaymentInfo) {
      this.recieptNumber = incomingPaymentInfo['recieptNumber'];
      this.documentID = incomingPaymentInfo['documentID'];
      if (incomingPaymentInfo['payment']) {
        this.payment = incomingPaymentInfo['payment'];
      }
      this.createdDate = incomingPaymentInfo['createdDate'];
      this.modifiedDate = incomingPaymentInfo['modifiedDate'];
      if (incomingPaymentInfo.applicationID) {
        this.applicationID = incomingPaymentInfo.applicationID;
        this.id = incomingPaymentInfo.id;
      }

      if(incomingPaymentInfo.inspectionID){
        this.inspectionID = incomingPaymentInfo.applicationID;
        this.id = incomingPaymentInfo.id;
      }
    }
  }
}

export class ChecklistInstance {
  checklistValueID: number;
  checkListValue: CheckListValueModel;
  screenerResponseValue: CheckListValueModel;
  screenerResponseValueID: number;
  checklistID: number;
  applicationID: number;
  checkListRef: ChecklistModel;
  id: number;
  createdDate: string;
  isActive: boolean;
  modifiedDate: string;
  rowGuid: string;
  compareResult: boolean;
}

export class CheckListValueModel {
  valueCode: string;
  description: string;
  name: string;
  shortName: string;
  id: number;
  createdDate: string;
  isActive: boolean;
  modifiedDate: string;
  rowGuid: string;
}

export class Facility {
    id: number;
    ownerName: string;
    ownerPhoneNumber: string;
    position: string;
    facilityTypeID: number;
    organizationTypeID: number;  
    applicationTypeID: number;
    applicationID: number;
    facilityCategoryID: string;
    facilityCategory: FacilityCategory;
    facilityCategoryName: string;
    isLegacyData: boolean;
    tinNumber: number;
    organization: Organization;
    name: string;
    type: FacilityType;
    isClosed: boolean;
    isFakeTin: boolean;

    constructor(incomingObject: any) {
      this.name = incomingObject['name'];
      this.ownerName = incomingObject['ownerName'];
      this.ownerPhoneNumber = incomingObject['ownerPhoneNumber'] || incomingObject['ownerPhone'];
      this.facilityCategoryID = incomingObject['facilityCategoryID'];
      this.facilityTypeID = incomingObject['facilityTypeID'];
      this.organizationTypeID = incomingObject['organizationTypeID'];   
      this.applicationTypeID = incomingObject['applicationTypeID'];
      this.tinNumber = incomingObject['tinNumber'];
    }
}

export class Location {
    id: number;
    regionID: number;
    zoneID: number;
    subCityID: number;
    woredaID: number;
    cityID: number;
    kebele: string;
    houseNo: string;
    phoneNo: string;
    areaName: string;

    constructor (incomingObject: any) {
       this.id = incomingObject['id'];
       this.regionID = incomingObject['regionID'];
       this.zoneID = incomingObject['zoneID'];
       this.subCityID = incomingObject['subCityID'];
       this.woredaID = incomingObject['woredaID'];
       this.cityID = incomingObject['cityID'];
       this.kebele = incomingObject['kebele'];
       this.houseNo = incomingObject['houseNo'];
       this.phoneNo = incomingObject['phoneNo'] || incomingObject['phoneNumber'];
       this.areaName = incomingObject['areaName'];
       this.removeEmptyValues();
    }
    public removeEmptyValues() {
        this.regionID = this.regionID === -1 ? null : this.regionID;
        this.zoneID = this.zoneID === -1 ? null : this.zoneID;
        this.woredaID = this.woredaID === -1 ? null : this.woredaID;
        this.subCityID = this.subCityID === -1 ? null : this.subCityID;
        this.cityID = this.cityID === -1 ? null : this.cityID;
        this.kebele = this.kebele === '' ? null : this.kebele;
        this.houseNo = this.houseNo === '' ? null : this.houseNo;
        this.phoneNo = this.phoneNo === '' ? null : this.phoneNo;
        this.areaName = this.areaName === '' ? null : this.areaName;
    }

}

export class Professionals {
        name: string;
        phone: string;
        email: string;
        educationLevelID: number;
        qualificationID: string;
        experience: number;
        regNumber: string;
        professionalTypeID: number;

    constructor(incomingObject: any, professionalType: string) {
      if (professionalType === Constants.TECHNICAL_LEADER_CODE) {
        this.name =  incomingObject['tlName'];
        this.phone = incomingObject['tlPhoneNumber'];
        this.email = incomingObject['tlEmail'];
        this.educationLevelID = incomingObject['tlEducationLevelID'];
        if ( incomingObject['tlQualificationID']) {
          this.qualificationID = incomingObject['tlQualificationID'];
        } else {
          this.qualificationID = incomingObject['tlQualification'];
        }
        this.experience = incomingObject['tlExperience'];
        this.regNumber = incomingObject['tlProfessionalLicenseNumber'];
        this.professionalTypeID = 1;
      } else if (professionalType === Constants.PRODUCTION_MANAGER_CODE) {
        this.name =  incomingObject['pmName'];
        this.email = incomingObject['pmEmail'];
        this.phone = incomingObject['pmPhoneNumber'];
        this.educationLevelID = incomingObject['pmEducationLevelID'];
        if ( incomingObject['pmQualificationID']) {
          this.qualificationID = incomingObject['pmQualificationID'];
        } else {
          this.qualificationID = incomingObject['pmQualification'];
        }
        this.experience = incomingObject['pmExperience'];
        this.regNumber = incomingObject['pmProfessionalLicenseNumber'];
        this.professionalTypeID = 2;
      } else if (professionalType === Constants.QUALITY_ASSURANCE_CODE) {
        this.name =  incomingObject['qaName'];
        this.email = incomingObject['qaEmail'];
        this.phone = incomingObject['qaPhoneNumber'];
        this.educationLevelID = incomingObject['qaEducationLevelID'];
        if ( incomingObject['qaQualificationID']) {
          this.qualificationID = incomingObject['qaQualificationID'];
        } else {
          this.qualificationID = incomingObject['qaQualification'];
        }
        this.experience = incomingObject['qaExperience'];
        this.regNumber = incomingObject['qaProfessionalLicenseNumber'];

        this.professionalTypeID = 3;
      } else if (professionalType === Constants.HYGIENE_AND_SANITATION_EXPERT_CODE) {
        this.name =  incomingObject['hseName'];
        this.email = incomingObject['hseEmail'];
        this.phone = incomingObject['hsePhoneNumber'];
        this.educationLevelID = incomingObject['hseEducationLevelID'];
        if ( incomingObject['hseQualificationID']) {
          this.qualificationID = incomingObject['hseQualificationID'];
        } else {
          this.qualificationID = incomingObject['hseQualification'];
        }
        this.experience = incomingObject['hseExperience'];
        this.regNumber = incomingObject['hseProfessionalLicenseNumber'];
        this.professionalTypeID = 5;
      } else if (professionalType === Constants.STORE_MANAGER_CODE) {
        this.name =  incomingObject['smName'];
        this.email = incomingObject['smEmail'];
        this.phone = incomingObject['smPhoneNumber'];
        this.educationLevelID = incomingObject['smEducationLevelID'];
        if ( incomingObject['smQualificationID']) {
          this.qualificationID = incomingObject['smQualificationID'];
        } else {
          this.qualificationID = incomingObject['smQualification'];
        }
        this.experience = incomingObject['smExperience'];
        this.regNumber = incomingObject['smProfessionalLicenseNumber'];

        this.professionalTypeID = 4;
      } else if (professionalType === Constants.PHYSICO_CHEMICAL_EXPERT_CODE) {
        this.name =  incomingObject['pceName'];
        this.email = incomingObject['pceEmail'];
        this.phone = incomingObject['pcePhoneNumber'];
        this.educationLevelID = incomingObject['pceEducationLevelID'];
        if ( incomingObject['pceQualificationID']) {
          this.qualificationID = incomingObject['pceQualificationID'];
        } else {
          this.qualificationID = incomingObject['pceQualification'];
        }
        this.experience = incomingObject['pceExperience'];
        this.regNumber = incomingObject['pceProfessionalLicenseNumber'];
        this.professionalTypeID = 6;
      } else if (professionalType === Constants.MICROBIOLOGIST_CODE) {
        this.name =  incomingObject['mbName'];
        this.email = incomingObject['mbEmail'];
        this.phone = incomingObject['mbPhoneNumber'];
        this.educationLevelID = incomingObject['mbEducationLevelID'];
        if ( incomingObject['mbQualificationID']) {
          this.qualificationID = incomingObject['mbQualificationID'];
        } else {
          this.qualificationID = incomingObject['mbQualification'];
        }
        this.experience = incomingObject['mbExperience'];
        this.regNumber = incomingObject['mbProfessionalLicenseNumber'];
        this.professionalTypeID = 7;
      }else if (professionalType === Constants.Quality_CONTROL_CODE) {
        this.name =  incomingObject['qcName'];
        this.email = incomingObject['qcEmail'];
        this.phone = incomingObject['qcPhoneNumber'];
        this.educationLevelID = incomingObject['qcEducationLevelID'];
        if ( incomingObject['qcQualificationID']) {
          this.qualificationID = incomingObject['qcQualificationID'];
        } else {
          this.qualificationID = incomingObject['qcQualification'];
        }
        this.experience = incomingObject['qcExperience'];
        this.regNumber = incomingObject['qcProfessionalLicenseNumber'];

        this.professionalTypeID = 8;
      } else if (professionalType === Constants.WAREHOUSE_MANAGER_CODE) {
        this.name =  incomingObject['wmName'];
        this.email = incomingObject['wmEmail'];
        this.phone = incomingObject['wmPhoneNumber'];
        this.educationLevelID = incomingObject['wmEducationLevelID'];
        if ( incomingObject['wmQualificationID']) {
          this.qualificationID = incomingObject['wmQualificationID'];
        } else {
          this.qualificationID = incomingObject['wmQualification'];
        }
        this.experience = incomingObject['wmExperience'];
        this.regNumber = incomingObject['wmProfessionalLicenseNumber'];

        this.professionalTypeID = 9;
      } 
      this.regNumber = this.regNumber === '' ? null : this.regNumber;
      this.removeEmptyValues();
    }

    public removeEmptyValues() {
        this.name =   this.name === '' ? null : this.name;
    }
}

export class Document {
    public id: number;
    public referenceID: number;
    public recieptNumber: string;
    public filePath: string;

    constructor(response: any) {
        this.id = response.id;
        this.referenceID = response.referenceID;
        this.filePath = response.filePath;
    }
}

export class ApplicationView {
    id: number;
    facilityID: number;
    facilityName: string;
    applicationStatusID: number;
    createdBy: number;
    createdByName: string;
    applicationCategoryName: string;
    applicationStatusCode: string;
    applicationStatusName: string;
    facilityTypeName: string;
    productType: string;
    assignedUserID: number;
    assignedUser: string;
    createdDate: string;
    modifiedDate: string;
    assignedUserInThePastID: number;
    ticketNo: string;
    dueDate: string;
    flowTypeID: number;
    flowTypeName: string;
    facilityCategoryName: string;
    branchOfficeID: number;
    facilityPhone: string;
    subCity: string;

}

export class FacilitySpecificProduct {
  public id: number;
  public applicationID: number;
  public specificProductID: number;
  public specificProduct: SpecificProduct;
  constructor(specificProductID) {
    this.specificProductID = specificProductID;
  }
}
export class FacilitySpecificProductItem {
  public id: number;
  public applicationID: number;
  public specificProductItemID: number;
  public specificProductItem: SpecificProductItem;
  public brandName: string;

  constructor(specificProductItemID) {
    this.specificProductItemID = specificProductItemID;
    
  }
}

export class FacilityView {
  id: number;
  name: string;
  facilityTypeID: number;
  productTypeID: number;
  applicantName: string;
  facilityTypeName: string;
  productTypeName: string;
  facilityEmail: string;
  applicationID: number;
  applicationNumber: string;
  createdDate: string;
  modifiedDate: string;
  extendedExpiryDate: Date;
  isExpired: boolean;
  isLegacyData: boolean;
  expirationDate: string;
  licenseDate: string;
  mLevelID: number;
  mrLevelID: number;
  applicationStatusCode: string;
  facilityCategoryName: string;
  facilityCategoryID: number;
  licenseID: number;
  organizationTypeCode: string;
  ownershipTypeCode: string;
}

export class FlowType {
  flowTypeCode: string;
  name: string;
  id: number;
  createdDate: string;
  isActive: boolean;
  modifiedDate: string;
  rowGuid: string;
}

export class OrphanInspectionFacility {
  ownerPhone: string;
  facilityPhone: string;
  facilityID: number;
  facilityTypeName: string;
  productTypeName: string;
  facilityTypeID: number;
  productTypeID: number;
  name: string;
  facilityEmail: string;
  id: number;
  typeID: number;
  createdDate: string;
  isActive: boolean
  modifiedDate: string;
  rowGuid: string;
}

export class ChangeConfig {
  facilityId: number;
  changeTypeRefId: number;
  documents: DocumentRef[];
  fee: number;
}
export class ReplacementReason{
  id: number;
  name: string;

  constructor(id , name){
    this.id = id;
    this.name = name;
  }
}

export class ApplicationInfo{
  id: number;
  applicationID: number;
  summary: string;
  replacementReasonID: number;
  replacementReason : ReplacementReason;

  constructor(incomingObject: any){
    this.id = incomingObject.id;
    this.applicationID = incomingObject.applicationID;
    this.summary = incomingObject.summary;
    this.replacementReasonID = incomingObject.replacementReasonID;
    this.replacementReason = incomingObject.replacementReason;
  }
}

export class ODKResponse {
  form: string;
  model: string;
  instance: string;
}

export class Organization {
  id : number;
  tinNumber: string;
  organizationTypeID: number;
  address: string;
  type: OwnershipType;
  name: string;
  ownerName: string;
  ownerPhone: string;
}

export class UserOrganization {
  id: number;
  tinNumber: string;
  userID: number;
  applicantTypeID: number;
  organization: Organization;
  applicantType: ApplicantType;
  applicantDto: UserDto;
}

export class ReturnReason {
  id: number;
  name: string;
  description: string;
  createdDate: string;
  modifiedDate: string;
  isActive: boolean;
  rowGuid: string;
}

export class ReasonByProductType {
  id: number;
  reasonID: string;
  productTypeID: string;
  reason: ReturnReason;
  createdDate: string;
  modifiedDate: string;
  isActive: boolean;
  rowGuid: string;
}

export class ChangeFakeTinModel {
  facilityID: number;
  newTin: string;

  constructor(facilityId, newTin) {
    this.facilityID = facilityId;
    this.newTin = newTin;
  }
}

export class PendingPaymentInfo {
  paymentMethod: string;
  amount: number;
  billReferenceNumber: string;
  customerName: string;
}

export class PaymentRequest {
  title: string;
  amount: number;
  /** Required by api/Telebirr/CreateOrder — merchant order id / bill reference for notify reconciliation. */
  billReferenceNumber: string;
  /** Optional Telebirr product override: 'C2B' (H5 consumer) or 'B2B' (H5 business). When omitted the backend's TelebirrConfig.CheckoutMode is used. */
  checkoutMode?: string;
}

export class PaymentConfirmation {
  billReferenceNumber: string;
  transactionId: string;
  serviceProvider: string;
}